import BaseClass from 'application/BaseClass';


class AdDimension extends BaseClass {
  constructor(prefix = '', sizesTuple){
    super(...arguments);
    const [width, height, ] = sizesTuple;
    this.merge({ width, height, prefix, });
  }
  get sizesTuple(){
    return [this.width, this.height, ];
  }
  toString(){
    return `${ this.prefix }${ this.sizesTuple.join('x') }`;
  }
  get self(){
    const instance = this;
    return {
      [this.toString()]: instance,
    };
  }
  valueOf(){
    return this.sizesTuple;
  }
}

// Function.part didn't work here :(
const DisplayAdDimension = AdDimension.bind(null, 'd');
const VideoAdDimension = AdDimension.bind(null, 'v');

function addSizeToSizes(sizesObj, sizeInstance){
  return Object.assign(sizesObj, sizeInstance.self);
}

function sizesArrayToObj(DimensionClass, sizes){
  return sizes
    // Safari is steaming pile of code manure. Dig into it for answers
    // .create from BaseClass is not recognized by Safari
    .map(dimensionTuple => new DimensionClass(dimensionTuple))
    .reduce(addSizeToSizes, {});
}

const AD_DIMENSIONS = {
  DISPLAY: sizesArrayToObj(DisplayAdDimension, [
    [970, 250], [970, 90], [970, 90],
    [900, 250],
    [728, 90],
    [320, 50],
    [300, 600], [300, 300], [300, 250], [300, 50],
    [1, 1],
  ]),
  VIDEO: sizesArrayToObj(VideoAdDimension, [[640, 360], ]),
};

export { AD_DIMENSIONS, };
export default Object.assign({}, AD_DIMENSIONS.DISPLAY, AD_DIMENSIONS.VIDEO);



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/config/adDimensionsConfig.js